var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStateNeedsReview = function SvgStateNeedsReview(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 13.8V15.78L17.0889 16.68M15.6667 4.8H17.4444C17.9159 4.8 18.3681 4.98964 18.7015 5.32721C19.0349 5.66477 19.2222 6.12261 19.2222 6.6V7.3488M8.55556 4.8H6.77778C6.30628 4.8 5.8541 4.98964 5.5207 5.32721C5.1873 5.66477 5 6.12261 5 6.6V19.2C5 19.6774 5.1873 20.1352 5.5207 20.4728C5.8541 20.8104 6.30628 21 6.77778 21H8.55556M21 15.6C21 18.5823 18.6122 21 15.6667 21C12.7211 21 10.3333 18.5823 10.3333 15.6C10.3333 12.6177 12.7211 10.2 15.6667 10.2C18.6122 10.2 21 12.6177 21 15.6ZM9.44444 3H14.7778C15.2687 3 15.6667 3.40294 15.6667 3.9V5.7C15.6667 6.19706 15.2687 6.6 14.7778 6.6H9.44444C8.95352 6.6 8.55556 6.19706 8.55556 5.7V3.9C8.55556 3.40294 8.95352 3 9.44444 3Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStateNeedsReview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "state-needs-review.133c753d557746fddde2b6cdd1341b57.svg";